import { createSlice } from "@reduxjs/toolkit";

import { getBrandList, addBrandList, updateBrandList, deleteBrandList } from "./thunk";

export const initialState = {
    brandList: {
        content: []
    },
    errors: {}
};

const BrandSlice = createSlice({
    name: 'Brand',
    initialState,
    reducers: {},
    extraReducers: (builder) => {

        builder.addCase(getBrandList.fulfilled, (state: any, action: any) => {
            state.brandList = action.payload;
        });
        builder.addCase(getBrandList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(addBrandList.fulfilled, (state: any, action: any) => {
            console.log(action.payload)
            state.brandList.content.unshift(action.payload);
        });
        builder.addCase(addBrandList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(updateBrandList.fulfilled, (state: any, action: any) => {
            state.brandList.content = state.brandList.content.map((category: any) =>
                category.id === action.payload.id
                    ? { ...category, ...action.payload }
                    : category
            );
        });

        builder.addCase(updateBrandList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(deleteBrandList.fulfilled, (state: any, action: any) => {
            state.brandList.content = state.brandList.content.filter(
                (brandList: any) => brandList.id !== action.payload
            );
            console.log(action.payload)
        });
        builder.addCase(deleteBrandList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
    }
});

export default BrandSlice.reducer;